import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { PageAnalytics } from "@/components/page-analytics";
import { Providers } from "@/components/providers";
import App from "./App";
import "./vendor/chat-shell/styles/loading.css";
import "./index.css";
import "./lib/wannlabs/wl-ambient.js";
createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <BrowserRouter>
      <PageAnalytics />
      <Providers><App /></Providers>
    </BrowserRouter>
  </StrictMode>,
);
